// extracted by mini-css-extract-plugin
module.exports = {"button":"CategoryItem_button__3mCRr common_discipline__3uTNt","rotate":"CategoryItem_rotate__3RDj0","slideIn":"CategoryItem_slideIn__3ZVA3","fadeIn":"CategoryItem_fadeIn__SDeP7"};